module.exports = __webpack_public_path__ + "components/MapControl/svg/Dom kultury_świetlica.svg?639df671";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Dom kultury_świetlica.svg
// module id = 2024
// module chunks = 0